export default __webpack_public_path__ + "static/media/53983d1d0d6693557f40f7d20ebebffd.csv";